import { ILoggingService } from "./ILoggingService";

export let log: (item: any) => void = () => { };
export let logException: (error: any) => void = () => { };

export const initialize = (logService: ILoggingService) => {
    log = logService.log;
    logException = logService.logException;
}